export default "__VITE_ASSET__DDV7Dyu3__"